import * as React from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_LIST_DEFINITIONS } from 'flow-doctor-lib/queries/ListQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FallbackListNameLabel = ({
  maybeListDefinition,
  listId,
  isInternal
}) => {
  if (maybeListDefinition) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: maybeListDefinition.name
    });
  }
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: isInternal ? 'flow-doctor-lib.references.list.unknownListInternal' : 'flow-doctor-lib.references.list.unknownListExternal',
      options: {
        listId: listId.toString()
      }
    }), /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "m-left-1",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.references.list.unknownListTooltip"
      }),
      tooltipPlacement: "top"
    })]
  });
};
const ListNameLabel = ({
  portalId,
  listId,
  isClassic = false,
  showId = false
}) => {
  const {
    loading,
    error,
    data
  } = useQuery(GET_LIST_DEFINITIONS, {
    // Classic list ids are prefixed with a "c-" as input to this endpoint
    variables: {
      portalId,
      listIds: [isClassic ? `c-${listId}` : listId]
    }
  });
  if (error) {
    return /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: getIsInternal() ? 'flow-doctor-lib.references.list.unknownListInternal' : 'flow-doctor-lib.references.list.unknownListExternal',
        options: {
          listId
        }
      })
    });
  }
  if (loading || !data) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  const listDefinition = data.listDefinitions[0];
  return /*#__PURE__*/_jsx("span", {
    children: listDefinition && showId ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.references.list.labelWithId",
      options: {
        listName: listDefinition.name,
        listId: listDefinition.listId.toString()
      }
    }) : /*#__PURE__*/_jsx(FallbackListNameLabel, {
      maybeListDefinition: listDefinition,
      listId: listId,
      isInternal: getIsInternal()
    })
  });
};
export default ListNameLabel;